import { gql } from '@zenbusiness/application-commons-graphql';

export const ADDRESS_FIELDS = gql`
  fragment addressFields on Address {
    address1
    address2
    city
    state
    zip
    county
    country
    mailboxIdentifier
  }
`;
